import React from 'react';

const Page404 = () => (<h2 style={{ textAlign: 'center' }}>Ooops! 404</h2>);

export default Page404;
